import React, {Component} from 'react';
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import API from "../../services/API";
import Slideshow from "../Common/HomeSlideshow";
import Clock from 'react-live-clock';
import JCalendar from 'reactjs-persian-calendar'

class Home extends Component {
    state = {
        user: null
    }

    render() {

        return (
            <React.Fragment>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>
                        <div className="col-md-9">

                            <div className="row ">
                                <div className="col-12 mb-5">
                                    <TopMenu/>
                                </div>
                                <div className="col-md-9">

                                        <Slideshow/>


                                </div>
                                <div className="col-md-3  py-2 ">
                                    <div className="usual-content mb-2 text-center">

                                        <Clock format="HH:mm:ss"
                                               interval={1000}
                                               ticking={true}
                                               timezone={'Asia/Tehran'}


                                        />


                                    </div>
                                    <div className="usual-content mb-2 text-center">
                                        <JCalendar
                                            locale={'fa'}
                                            color={'#016064'}
                                            size={30}

                                        />
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>

                </section>

            </React.Fragment>
        );
    }

    componentDidMount() {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/')
        }
        const push_id = window.localStorage.getItem("npid");
        if(push_id) {
            const request = {
                push_id
            }
            API.setPushToken(request)
                .then((response) => {

                    const user = response.results.user;
                    this.setState({user});
                })
        }

        API.index()
            .then((response) => {

                const user = response.results.user;
                this.setState({user});
            })
    }
}

export default Home;